import SearchIndex from '@component/SearchIndex';
import { createStaticPropsFetcher } from '@lib/fetch/getStaticProps';

import type { GetStaticProps, NextPage } from 'next';

const SearchView: NextPage = () => {
  return <SearchIndex />;
};

export const getStaticProps: GetStaticProps = createStaticPropsFetcher('search');

export default SearchView;
